// src/constants/routes.js
export const ROUTES = {
  REGISTRATION: "/registration",
  ADMINSIGNIN: '/login',
  ADMINFORGOTPASSWORD: '/admin-forgot-password',
  DASHBOARD: "/dashboard",
  REMOTE: "/remote",
  MAINHOME: "/home",
  HOME: "/",
  SCHOOLMANAGEMENT: "/school-management",
  ADMINMANAGEMENT: "/admin-management",
  DIRECTORMANAGEMENT: "/director-management",
  HELPDESK: "/helpdesk",
  SCHOOLLIST: "/school-list",
  PRIVACYPOLICY:'/privacy-notice',
  TERMS:'/terms',
 GROUPLIST:'grouplist',
 SCHOOLONBOARDING:'school-onboarding',
 SCHOOLSUPPORT:'School-Support',
 SCHOOLLEAD:'School-Lead',
  ADMIN_WEB_MENU:'/admin-web-menu',
  PARENT_APP_MENU:'/parent-app-menu',
  LIVE_USER_MANAGEMENT:'/live-user-management',
  UNAUTHORIZED:'/unauthorized',
};

export const ROLES = {
  ADMIN: "admin",
  SALES: "sales",
  SUPPORT: "support",
  SALESANDSUPPORT: "salesandsupport",
};
